(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('BlockedPhone', BlockedPhone);

    BlockedPhone.$inject = ['$resource', 'DateUtils'];

    function BlockedPhone ($resource, DateUtils) {
        var resourceUrl =  'api/blocked-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastCallTime = DateUtils.convertDateTimeFromServer(data.lastCallTime);
                        data.blockingTime = DateUtils.convertDateTimeFromServer(data.blockingTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
